import { render, staticRenderFns } from "./testData.vue?vue&type=template&id=6f4955b3&"
import script from "./testData.vue?vue&type=script&lang=js&"
export * from "./testData.vue?vue&type=script&lang=js&"
import style0 from "./testData.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports